module.exports = __webpack_public_path__ + "static/tone sms-9a59cff09a6961ecfd482dff858d4ae2.png";